import React from "react";
import { IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import OsCreateForm from "../../components/OsCreateForm";

const NovaOrdemServico = () => {
  const history = useHistory();

  return (
    <MainContainer maxWidth={false}>
      <MainHeader>
        <IconButton onClick={() => history.push("/ordens-servico")}>
          <ArrowBackIcon />
        </IconButton>
        <Title>Nova ordem de serviço</Title>
        <MainHeaderButtonsWrapper />
      </MainHeader>
      <OsCreateForm
        onCancel={() => history.push("/ordens-servico")}
        onCreated={order => history.push(`/ordens-servico/${order.id}`)}
      />
    </MainContainer>
  );
};

export default NovaOrdemServico;
